import React from 'react'
import Slider from "react-slick";
import { getImages } from '../const';
const carData = [
    {
        image: 'fv-img2.jpg',
        title: '2023 Bentley Bentayga',
        price: '$199,995',
        mileage: '3,767mi',
    },
    {
        image: 'fv-img3.jpg',
        title: '2016 Bentley Continental GT',
        price: '$109,995',
        mileage: '11,682mi',
    },
    {
        image: 'fv-img6.jpg',
        title: '2019 Chevrolet Corvette',
        price: '$99,995',
        mileage: '3,026mi',
    },
]
const carData1 = [
    {
        image: 'fv-img1.jpg',
        title: '2024 Audi S5 Cabriolet',
        price: '$64,995',
        mileage: '575mi',
    },
    {
        image: 'fv-img4.jpg',
        title: '1969 Chevrolet Camaro SS',
        price: '$69,995',
        mileage: '7,194mi',
    },
    {
        image: 'fv-img5.jpg',
        title: '2021 Chevrolet Corvette',
        price: '$71,995',
        mileage: '8,030mi',
    },
]
const FeaturedVehicles = () => {

    var featuredSettings1 = {
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        draggable: false,
        focusOnSelect: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        rtl: true
    };
    var featuredSettings2 = {
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        draggable: false,
        focusOnSelect: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    };
    return (
        <>
            <section className='featured-vehicles-wrap'>
                <div className='container'>
                    <div className='main-title tex-center'>
                        <span className='position-relative add-before-border add-after-border'>Featured Vehicles</span>
                    </div>
                    <div className='featured-vehicles-block'>
                        <Slider {...featuredSettings1}>
                            {carData.map((car, index) => (
                                <div key={index}>
                                    <div className='inner'>
                                        <article className="cs-card cs-card--2 fv-box">
                                            <div className="cs-card__img fv-top"
                                                style={{
                                                    backgroundImage: `url(${getImages(car.image)})`,
                                                }}
                                            ></div>
                                            <a href="#" className="cs-card_link">
                                                <div className="cs-card__img--hover fv-top"
                                                    style={{
                                                        backgroundImage: `url(${getImages(car.image)})`,
                                                    }}></div>
                                            </a>
                                            <div className="fv-bottom">
                                                <div className="sm-title text-orange font-bold">{car.title}</div>
                                                <div className="d-flex align-items-center justify-content-between mt-1">
                                                    <div className="sm-title">{car.price}</div>
                                                    <div className="sm-title opacity-0-4">{car.mileage}</div>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                        <Slider {...featuredSettings2}>
                            {carData1.map((car, index) => (
                                <div key={index}>
                                    <div className='inner'>
                                        <article className="cs-card cs-card--2 fv-box">
                                            <div className="cs-card__img fv-top"
                                                style={{
                                                    backgroundImage: `url(${getImages(car.image)})`,
                                                }}
                                            ></div>
                                            <a href="#" className="cs-card_link">
                                                <div className="cs-card__img--hover fv-top"
                                                    style={{
                                                        backgroundImage: `url(${getImages(car.image)})`,
                                                    }}></div>
                                            </a>
                                            <div className="fv-bottom">
                                                <div className="sm-title text-orange font-bold">{car.title}</div>
                                                <div className="d-flex align-items-center justify-content-between mt-1">
                                                    <div className="sm-title">{car.price}</div>
                                                    <div className="sm-title opacity-0-4">{car.mileage}</div>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FeaturedVehicles